// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PCUserPortCallEditor\ApiPCUserPortCallEditor.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';

// PCUserPortCallEditorData is the class that PCUserPortCallEditor serializes to/from
export interface PCUserPortCallEditorData {
    PortCallEditorId : number;
    PortCallOwnerId : number;
    Url : string | null;
	
    PortCallEditor : PCUserData | null;
    PortCallOwner : PCUserData | null;
	
    Guid : /* GUID */ string;
}

// PCUserPortCallEditorOptions is the class which may be passed to the PCUserPortCallEditor constructor to define optional initial data values
export interface PCUserPortCallEditorOptions {
    PortCallEditorId : number;
    PortCallOwnerId : number;
    Url? : string | null;
	
    PortCallEditor? : PCUserOptions | null;
    PortCallOwner? : PCUserOptions | null;
	
    Guid? : /* GUID */ string;
}

export class PCUserPortCallEditor {
    public PortCallEditorId : DataSignal<number>;
    public PortCallOwnerId : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public PortCallEditor : DataSignal<PCUser | null>;
    public PortCallOwner : DataSignal<PCUser | null>;
	
    public Guid : DataSignal<string>;

    constructor();
    constructor(data : PCUserPortCallEditorOptions);
    constructor(data: PCUserPortCallEditorOptions | null = null) {
        this.PortCallEditorId = jsonableObservable(S.value<number>(data && data.PortCallEditorId !== undefined ? data.PortCallEditorId : 0));
        this.PortCallOwnerId = jsonableObservable(S.value<number>(data && data.PortCallOwnerId !== undefined ? data.PortCallOwnerId : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.PortCallEditor = S.value<PCUser | null>(null);
        this.PortCallOwner = S.value<PCUser | null>(null);
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
    }

    static key(obj : PCUserPortCallEditor) {
        return obj.PortCallEditorId() + '\u2618' + obj.PortCallOwnerId();
    }
    
    static dataKey(obj : PCUserPortCallEditorOptions) {
        return obj.PortCallEditorId + '\u2618' + obj.PortCallOwnerId;
    }

    static update(obj : PCUserPortCallEditor, data : PCUserPortCallEditorOptions) {
        S.freeze(() => {
            if (data.PortCallEditorId !== undefined) obj.PortCallEditorId(data.PortCallEditorId);
            if (data.PortCallOwnerId !== undefined) obj.PortCallOwnerId(data.PortCallOwnerId);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PCUserPortCallEditor.ts